<template>
	<v-card class="mt-3">
		<v-card-title>
			<h2>{{departmentName}}</h2>
		</v-card-title>
		<correspondence-templates-list
			:possible-tags="possibleTags"
			:correspondenceTemplates="correspondenceTemplates"
			color="indigo"
			header="Szablony pism"/>
	</v-card>
</template>

<script>
	import CorrespondenceTemplatesList from "./CorrespondenceTemplatesList";
	import {Department} from "../../../api/generated/Department";
	import {Correspondence} from "../../../api/generated/Correspondence";
	import {PossibleTagsDict} from "../../../utils/PossibleTagsDict";

	export default {
		name: "CorrespondenceTemplatesView",
		components: {CorrespondenceTemplatesList},
		methods: {
			refresh() {
				loadTemplates(this);
				loadDepartmentName(this);
			},
		},

		watch: {
			"$route.params": function () {
				this.refresh();
			},
		},


		data() {
			return {
				correspondenceTemplates: [],
				departmentName: "",
				possibleTags: []
			};
		},

		created() {
			this.possibleTags = PossibleTagsDict.getCorrespondenceTags();
			this.refresh();
		},
	};

	function loadTemplates(ctx) {
		Correspondence.getList(ctx, ctx.$route.params.departmentId, successResponse => {
				ctx.correspondenceTemplates = successResponse;
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować szablonów", errorResponse);
			});
	}

	function loadDepartmentName(ctx) {
		Department.getName(ctx, ctx.$route.params.departmentId, successResponse => {
				ctx.departmentName = successResponse.name;
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować nazwy departamentu", errorResponse);
			});
	}

</script>

<style scoped>

</style>
